module.exports = __webpack_public_path__ + "img/txlLogo.565c112a.jpg";